module.exports = __webpack_public_path__ + "img/table-premium.f3aea18.svg";